import { useState } from "react";

export default function MobileAppPopup({ community }) {
  const [visible, setVisible] = useState(true);

  if (!community || !visible || true) return <></>; //  disable permanently

  return (
    <div className="CommunityMobileAppPopup flex flex-col items-center justify-center shadow bg-white">
      <span>
        For better mobile experience of <b>{community.name}</b>
      </span>
      <a
        href="https://play.google.com/store/apps/details?id=com.pensil.note"
        className="bg-theme-primary text-white px-4 py-2 mt-4 cursor-pointer">
        Switch to App
      </a>
      <button
        className="text-theme-primary px-4 py-2 cursor-pointer"
        onClick={(e) => {
          setVisible(false);
        }}>
        Not now
      </button>
    </div>
  );
}
